var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnion = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_666_2060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9875 24.6625L15.35 40L28.9875 55.3375L31.65 58.325L25.675 63.6375L23.0125 60.65L7.0125 42.65L4.65 40L7.0125 37.3375L23.0125 19.3375L25.675 16.35L31.65 21.6625L28.9875 24.65V24.6625ZM51.0125 24.6625L48.35 21.675L54.325 16.3625L56.9875 19.35L72.9875 37.35L75.35 40L72.9875 42.6625L56.9875 60.6625L54.325 63.65L48.35 58.3375L51.0125 55.35L64.65 40L51.0125 24.6625Z",
    fill: "url(#paint0_linear_666_2060)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_666_2060",
    x: 4.65,
    y: 16.35,
    width: 70.7,
    height: 48.9152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.61516
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.807578
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_666_2060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_666_2060",
    x1: 66.6414,
    y1: 73.7636,
    x2: 1.30061,
    y2: 57.3963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E8E3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#E8E3DE",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E3DE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Union.9c2a3454.svg";
export { ForwardRef as ReactComponent };